import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 */


import { Utils } from '@logio/common-be-fe';
import { List } from 'immutable';
import { observable, runInAction } from 'mobx';
import { CRPLayer } from '../../transportLayers/data-cleaning/CRPLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of price zones.
 */

export var CRPStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(CRPStore, _BaseStore);

  function CRPStore() {
    var _this;

    _classCallCheck(this, CRPStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CRPStore).apply(this, arguments));
    _this.name = StoreName.CRP;
    _this.CRPLayer = new CRPLayer();
    _this.CRPAndFlags = new Map();
    _this.internalProductsMap = new Map();
    return _this;
  }

  _createClass(CRPStore, [{
    key: "getInternalProductCRPs",
    value: function getInternalProductCRPs(productId, competitorIds, priceZoneId) {
      var _this2 = this;

      return this.CRPLayer.findCRP(productId, competitorIds, priceZoneId).then(function (CRPs) {
        runInAction(function () {
          CRPs.forEach(function (CRP) {
            if (!_this2.internalProductsMap.get(productId)) {
              _this2.internalProductsMap.set(productId, List());
            }

            _this2.internalProductsMap.set(productId, _this2.internalProductsMap.get(productId).push(CRP));
          });
        });
      });
    }
  }, {
    key: "getCRPAndFlags",
    value: function getCRPAndFlags(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var CRPDTOs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.CRPLayer.findCRPAndFlags(params);

              case 3:
                CRPDTOs = _context.sent;
                runInAction(function () {
                  if (params.productId) {
                    _this3.CRPAndFlags.delete(params.productId);
                  }

                  CRPDTOs.map(function (crpDTO) {
                    var mapValue = _this3.CRPAndFlags.get(crpDTO.internalProductId);

                    if (Utils.isValueMissing(mapValue)) {
                      _this3.CRPAndFlags.set(crpDTO.internalProductId, List([crpDTO]));
                    } else {
                      _this3.CRPAndFlags.set(crpDTO.internalProductId, mapValue.push(crpDTO));
                    }
                  });
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", this.handleCatchError(_context.t0, 'getCRPAndFlags'));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));
    }
  }, {
    key: "getDTOForCompetitorAndZone",
    value: function getDTOForCompetitorAndZone(internalProductId, competitorId, priceZoneId) {
      var CRPDTOs = this.CRPAndFlags.get(internalProductId) ? this.CRPAndFlags.get(internalProductId) : undefined;
      return CRPDTOs ? CRPDTOs.find(function (crpDTO) {
        return crpDTO.competitorId === competitorId && crpDTO.priceZoneId === priceZoneId;
      }) : null;
    }
    /** RFC LOG-3142 for cleaning modal */

  }, {
    key: "getNewCRP",
    value: function getNewCRP(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.CRPLayer.findNewCRP(params);

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", this.handleCatchError(_context2.t0, 'getNewCRP'));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));
    }
  }, {
    key: "getInternalRegularPrice",
    value: function getInternalRegularPrice(internalProductId, competitorId, priceZoneId) {
      var crp = this.getDTOForCompetitorAndZone(internalProductId, competitorId, priceZoneId);

      if (!crp || !crp.internalRegularPrice || !crp.internalRegularPrice.value) {
        return null;
      }

      return crp.internalRegularPrice.value;
    }
  }]);

  return CRPStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Object)], CRPStore.prototype, "CRPAndFlags", void 0);

__decorate([observable, __metadata("design:type", Object)], CRPStore.prototype, "internalProductsMap", void 0);